/**
 * @generated SignedSource<<c52a3997e45b35f7c63a2976277cb7b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecapHistory_meetingRecording$data = {
  readonly activeSummary: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly meetingRecordedVideoDuration: number | null;
  readonly summaries: ReadonlyArray<{
    readonly actionItems: ReadonlyArray<{
      readonly assignees: ReadonlyArray<{
        readonly fullName: string;
        readonly userId: string | null;
      }>;
      readonly edited: boolean | null;
      readonly insertedBlockKey: string | null;
      readonly text: string;
      readonly timestamp: number;
    }> | null;
    readonly chapters: ReadonlyArray<{
      readonly bulletPoints: ReadonlyArray<{
        readonly context: string | null;
        readonly text: string;
        readonly textShort: string | null;
        readonly timestamp: number | null;
      }>;
      readonly timestamp: number | null;
      readonly title: string;
    }> | null;
    readonly createdAt: string;
    readonly creator: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
    } | null;
    readonly decisions: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"HighlightsPanel_DecisionsHighlight_decisions">;
    }> | null;
    readonly id: string;
    readonly summary: string | null;
  }>;
  readonly " $fragmentType": "RecapHistory_meetingRecording";
};
export type RecapHistory_meetingRecording$key = {
  readonly " $data"?: RecapHistory_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecapHistory_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecapHistory_meetingRecording",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoDuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingSummary",
      "kind": "LinkedField",
      "name": "activeSummary",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingSummary",
      "kind": "LinkedField",
      "name": "summaries",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptActionItem",
          "kind": "LinkedField",
          "name": "actionItems",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TranscriptActionItemAssignee",
              "kind": "LinkedField",
              "name": "assignees",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userId",
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "insertedBlockKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "edited",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptChapter",
          "kind": "LinkedField",
          "name": "chapters",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TranscriptBulletPoint",
              "kind": "LinkedField",
              "name": "bulletPoints",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "textShort",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "context",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptDecision",
          "kind": "LinkedField",
          "name": "decisions",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HighlightsPanel_DecisionsHighlight_decisions"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};
})();

(node as any).hash = "44c1c44bcf360a5e9b580f0ac22db74d";

export default node;
